module.exports = __webpack_public_path__ + "static/bbc-afb637ca854ced7c0770194f6e10665d.png";